import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { type AdminScreen, visibleScreensFor } from '../api.js';
import type { ServiceRole } from '../types.js';

export function RoleGate({
  roles,
  screen,
  children
}: {
  roles: ServiceRole[];
  screen: AdminScreen;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  if (!visibleScreensFor(roles).includes(screen)) {
    return <div className="panel muted">{t('roleGate.cannotAccess', { screen })}</div>;
  }
  return <>{children}</>;
}
